import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'missionmember/';

class BadgeService {

    getList() {
        return axios.get(API_URL + 'getlist/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    create(data) {
        return axios.put(API_URL + 'create/' + UserHelper.getClientId(), data, { headers: authHeader() });
    }

    update(memberId, data) {
        return axios.put(API_URL + 'update/' + memberId, data, { headers: authHeader() });
    }

    delete(id) {
        return axios.delete(API_URL + 'delete/' + id, { headers: authHeader() });
    }

    verifyCode(missionId, memberId, code) {
        return axios.post(
            API_URL + 'verify/' + missionId,
            { memberId, code },
            { headers: authHeader() }
        );
    }
}

export default new BadgeService();